<template>
  <div class="container page-notfound">
    <div class="hero is-medium is-primary">
      <div class="hero-body content">
        <div style="padding:30px;">
          <h1 class="title">
            Uh oh
          </h1>
          <h2 class="subtitle">
            Page Not Found
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'notfound',
    components: {
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

  .hero {
    &.is-primary {
      background-color: transparent;

      .title, .subtitle {
        color: gray;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// NotFound.vue?4bea5088